<div class="featured-products">
  <div class="featured-header">
    <h3>Featured Products</h3>
  </div>
  <div class="products-scroll-container">
    <div class="products-scroll">
      <div class="product-item" *ngFor="let product of featuredProducts">
        <zodi-product-item [product]="product"></zodi-product-item>
      </div>
    </div>
  </div>
</div>
